import { motion } from "framer-motion";
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import FormWithProvider from './FormWithProvider';
/**
 * 
 * @param {object} props (_formProp) 
 * @returns FormWithProvider wrapped in a `Form`
 * @description the formAttributes is added as attibutes to the `Form`
 */
const FormForm = (props) => {

  const { formAttributes } = props ?? {}

  // Pull out key if present
  const formKey = formAttributes?.key;

  // Remove key from attrs going into Form
  const _formAttributes = _.omit(formAttributes, ['key']);

  const formVariants = {
    hidden: { opacity: 0, y: -4 },
    visible: { opacity: 1, y: 0 },
  };

  return <motion.div
    initial="hidden"
    animate="visible"
    exit="hidden"
    variants={formVariants}
    transition={{ duration: 0.5 }}
  >
    <Form {..._formAttributes} key={formKey}  >
      <FormWithProvider {...props} />
    </Form>
  </motion.div>
}

export default FormForm